import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Tooltip, Skeleton } from 'antd';
import { LineContainer, Content, TitleTextStyle, ContentTextStyle } from './UI';
import eventsIcon from '@assets/images/events-layer.svg';

interface EventsLegendProps {
  isLoading: boolean;
  error?: string;
  total: number;
  onRemove?(): void;
}

export const EventsLegend: React.FC<EventsLegendProps> = ({
  error,
  isLoading,
  total,
  onRemove,
}) => {
  if (isLoading) {
    return (
      <LineContainer content={<Skeleton avatar paragraph={{ rows: 1 }} />} />
    );
  }

  if (error) {
    return (
      <LineContainer
        content={
          <Content
            content={`Не удалось отобразить легенду слоя афиши! ${error}`}
          />
        }
      />
    );
  }

  return (
    <>
      <LineContainer
        height={80}
        content={
          <>
            <Content style={TitleTextStyle} content="Афиша" />
            <div style={ContentTextStyle}>Количество объектов: {total}</div>
          </>
        }
        action={
          onRemove && (
            <Tooltip placement="left" title="Удалить слой">
              <CloseOutlined onClick={onRemove} />
            </Tooltip>
          )
        }
      />
      <div
        style={{
          paddingLeft: 25,
          marginTop: -20,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            width: 24,
            height: 24,
            backgroundImage: `url(${eventsIcon})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            display: 'inline-block',
          }}
        />
        <span style={{ marginLeft: 5 }}>Основной стиль</span>
      </div>
    </>
  );
};
